import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Button, Card, Badge, Spinner, Modal, Form } from "react-bootstrap";
import { FaEdit, FaArrowLeft, FaGlobe, FaPhone, FaMapMarkerAlt, FaCopy, FaSave, FaTimes } from 'react-icons/fa';
import { Link } from "react-router-dom";
import moment from 'moment';
import { getCompanyByID, updateCompany } from '../../actions/companyAction';

class CompanyView extends Component {
  state = {
    loading: false,
    company: null,
    showEditModal: false,
    editFormData: {
      name: '',
      legal_name: '',
      description: '',
      company_shortcode: '',
      address: '',
      tel: '',
      website: '',
      is_seller: false,
      is_factory: false,
      is_shipping_agency: false,
      is_system: false
    },
    editLoading: false
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id) {
      this.loadCompany(id);
    }
  }

  loadCompany = async (id) => {
    this.setState({ loading: true });
    try {
      const response = await this.props.getCompanyByID(id);
      if (response && response.data) {
        this.setState({ 
          company: response.data,
          editFormData: {
            name: response.data.name || '',
            legal_name: response.data.legal_name || '',
            description: response.data.description || '',
            company_shortcode: response.data.company_shortcode || '',
            address: response.data.address || '',
            tel: response.data.tel || '',
            website: response.data.website || '',
            is_seller: response.data.is_seller || false,
            is_factory: response.data.is_factory || false,
            is_shipping_agency: response.data.is_shipping_agency || false,
            is_system: response.data.is_system || false
          }
        });
      }
    } catch (error) {
      console.error('Error loading company:', error);
      alert('Lỗi khi tải thông tin công ty: ' + (error.response?.data?.message || error.message));
    } finally {
      this.setState({ loading: false });
    }
  };

  getCompanyTypesBadges = (company) => {
    const types = [];
    if (company.is_seller) types.push({ text: 'Seller', variant: 'primary' });
    if (company.is_factory) types.push({ text: 'Factory', variant: 'success' });
    if (company.is_shipping_agency) types.push({ text: 'Shipping Agency', variant: 'info' });
    if (company.is_system) types.push({ text: 'System', variant: 'warning' });
    
    return types.map((type, index) => (
      <Badge key={index} bg={type.variant} className="me-2 mb-1">
        {type.text}
      </Badge>
    ));
  };

  handleEditClick = () => {
    this.setState({ showEditModal: true });
  };

  handleCloseEdit = () => {
    this.setState({ showEditModal: false });
  };

  handleEditFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [name]: type === 'checkbox' ? checked : (name === 'company_shortcode' ? value.toUpperCase() : value)
      }
    });
  };

  validateEditForm = () => {
    const { editFormData } = this.state;
    
    if (!editFormData.name.trim()) {
      alert('Tên công ty không được để trống');
      return false;
    }

    if (!editFormData.company_shortcode.trim()) {
      alert('Mã công ty không được để trống');
      return false;
    }

    if (!/^[A-Z0-9]+$/.test(editFormData.company_shortcode)) {
      alert('Mã công ty chỉ được chứa chữ cái viết hoa và số');
      return false;
    }

    if (editFormData.company_shortcode.length < 2 || editFormData.company_shortcode.length > 20) {
      alert('Mã công ty phải từ 2-20 ký tự');
      return false;
    }

    // Check at least one company type (only for non-MyCompany views)
    if (!this.props.isMyCompany && !editFormData.is_seller && !editFormData.is_factory && !editFormData.is_shipping_agency && !editFormData.is_system) {
      alert('Vui lòng chọn ít nhất một loại công ty');
      return false;
    }

    return true;
  };

  handleSaveEdit = async () => {
    if (!this.validateEditForm()) return;

    this.setState({ editLoading: true });
    try {
      const { company } = this.state;
      const response = await this.props.updateCompany(company._id, this.state.editFormData);
      
      if (response && response.data) {
        // Update local state with new data
        this.setState({ 
          company: response.data,
          showEditModal: false 
        });
        alert('Cập nhật thông tin công ty thành công!');
      }
    } catch (error) {
      console.error('Error updating company:', error);
      alert('Lỗi khi cập nhật công ty: ' + (error.response?.data?.message || error.message));
    } finally {
      this.setState({ editLoading: false });
    }
  };

  render() {
    const { loading, company } = this.state;

    if (loading) {
      return (
        <Container fluid className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <div className="mt-2">Đang tải...</div>
        </Container>
      );
    }

    if (!company) {
      return (
        <Container fluid className="text-center py-5">
          <h4>Không tìm thấy thông tin công ty</h4>
          <Button variant="primary" as={Link} to="/admin/company-management">
            Quay lại danh sách
          </Button>
        </Container>
      );
    }

    return (
      <Container fluid>
        {!this.props.onHide && !this.props.isMyCompany && (
          <Row className="mb-4">
            <Col>
              <div className="d-flex align-items-center">
                <Button variant="outline-secondary" onClick={() => {
                  this.props.history.push('/admin/company-management');
                }} className="me-3">
                  <FaArrowLeft /> Quay lại
                </Button>
                <div>
                  <h2 className="mb-1">{company.name}</h2>
                  <span className="text-muted">ID: {company.company_id}</span>
                </div>
              </div>
            </Col>
            <Col className="text-end">
              <Button variant="warning" as={Link} to={`/admin/company-management/edit/${company._id}`}>
                <FaEdit /> Chỉnh sửa
              </Button>
            </Col>
          </Row>
        )}

        {!this.props.onHide && this.props.isMyCompany && (
          <div className="mb-5">
            {/* Hero Section */}
            <div className="text-center mb-4" style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '16px',
              padding: '3rem 2rem',
              color: 'white',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '200px',
                height: '200px',
                background: 'rgba(255,255,255,0.1)',
                borderRadius: '50%'
              }}></div>
              <div style={{
                position: 'absolute',
                bottom: '-30px',
                left: '-30px',
                width: '150px',
                height: '150px',
                background: 'rgba(255,255,255,0.05)',
                borderRadius: '50%'
              }}></div>
              
              <div style={{ position: 'relative', zIndex: 1 }}>
                {company.logo && (
                  <div className="mb-4">
                    <div style={{
                      display: 'inline-block',
                      padding: '20px',
                      background: 'rgba(255,255,255,0.15)',
                      borderRadius: '20px',
                      backdropFilter: 'blur(10px)'
                    }}>
                      <img 
                        src={company.logo} 
                        alt={`Logo ${company.name}`}
                        style={{ 
                          height: '100px',
                          width: 'auto',
                          maxWidth: '300px',
                          objectFit: 'contain',
                          borderRadius: '12px'
                        }}
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    </div>
                  </div>
                )}
                
                <h1 className="mb-3 text-center" style={{ 
                  fontSize: '2.5rem', 
                  fontWeight: '700',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>
                  {company.name}
                </h1>
                
                <div className="mb-3">
                  <span style={{ 
                    color: 'rgba(255,255,255,0.9)', 
                    fontSize: '1.1rem',
                    fontWeight: '500'
                  }}>
                    <a 
                      href={`https://${company.company_shortcode.toLowerCase()}.TKT1.ai`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: 'rgba(255,255,255,0.9)',
                        textDecoration: 'none',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.color = 'white';
                        e.target.style.textDecoration = 'underline';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = 'rgba(255,255,255,0.9)';
                        e.target.style.textDecoration = 'none';
                      }}
                    >
                      {company.company_shortcode.toLowerCase()}.TKT1.ai
                    </a>
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(`https://${company.company_shortcode.toLowerCase()}.TKT1.ai`);
                        // Show temporary feedback
                        const btn = event.target.closest('button');
                        const originalContent = btn.innerHTML;
                        btn.innerHTML = '<span style="color: white;">✓</span>';
                        setTimeout(() => { btn.innerHTML = originalContent; }, 1000);
                      }}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: 'rgba(255,255,255,0.8)',
                        marginLeft: '8px',
                        cursor: 'pointer',
                        padding: '4px',
                        borderRadius: '4px',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.color = 'white';
                        e.target.style.background = 'rgba(255,255,255,0.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = 'rgba(255,255,255,0.8)';
                        e.target.style.background = 'none';
                      }}
                      title="Copy link"
                    >
                      <FaCopy />
                    </button>
                  </span>
                </div>
                
                {company.legal_name && (
                  <div>
                    <span style={{ opacity: 0.8, fontSize: '0.95rem' }}>
                      {company.legal_name}
                    </span>
                  </div>
                )}
              </div>
            </div>




          </div>
        )}

        {this.props.onHide && (
          <Row className="mb-4">
            <Col md={3} className="text-center">
              {company.logo ? (
                <img 
                  src={company.logo} 
                  alt={`Logo ${company.name}`}
                  style={{ 
                    height: '80px',
                    width: 'auto',
                    maxWidth: '100%',
                    objectFit: 'contain',
                    borderRadius: '8px',
                    border: '1px solid #dee2e6'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              {company.logo && (
                <div 
                  style={{ 
                    height: '80px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    borderRadius: '8px',
                    display: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    color: '#6c757d'
                  }}
                >
                  Error
                </div>
              )}
              {!company.logo && (
                <div 
                  style={{ 
                    height: '80px',
                    backgroundColor: '#f8f9fa',
                    border: '1px dashed #dee2e6',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    color: '#6c757d'
                  }}
                >
                  No Logo
                </div>
              )}
            </Col>
            <Col md={9}>
              <h4 className="mb-1">{company.name}</h4>
              {company.legal_name && (
                <span className="text-muted">{company.legal_name}</span>
              )}
            </Col>
          </Row>
        )}

        <Row className="justify-content-center">
          <Col md={this.props.isMyCompany ? 10 : 8}>
            <Card className="mb-4 shadow-sm">
              <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  <i className="fas fa-info-circle me-2"></i>
                  Thông tin cơ bản
                </h5>
                {this.props.isMyCompany && (
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={this.handleEditClick}
                    style={{
                      borderRadius: '20px',
                      padding: '6px 12px',
                      transition: 'all 0.2s ease'
                    }}
                    title="Chỉnh sửa thông tin"
                  >
                    <FaEdit />
                  </Button>
                )}
              </Card.Header>
              <Card.Body className="p-4">
                <div className="mb-3">
                  <strong>Tên công ty:</strong>
                  <div className="mt-1">{company.name}</div>
                </div>

                {company.legal_name && (
                  <div className="mb-3">
                    <strong>Tên pháp lý:</strong>
                    <div className="mt-1">{company.legal_name}</div>
                  </div>
                )}

                <div className="mb-3">
                  <strong>Mã công ty:</strong>
                  <div className="mt-1">
                    <code className="bg-light px-2 py-1 rounded">{company.company_shortcode}</code>
                  </div>
                </div>

                {company.description && (
                  <div className="mb-3">
                    <strong>Mô tả:</strong>
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {company.description}
                    </div>
                  </div>
                )}

                {company.address && (
                  <div className="mb-3">
                    <strong><FaMapMarkerAlt /> Địa chỉ:</strong>
                    <div className="mt-1">{company.address}</div>
                  </div>
                )}

                <Row>
                  {company.tel && (
                    <Col md={6}>
                      <div className="mb-3">
                        <strong><FaPhone /> Số điện thoại:</strong>
                        <div className="mt-1">
                          <a href={`tel:${company.tel}`}>{company.tel}</a>
                        </div>
                      </div>
                    </Col>
                  )}
                  {company.website && (
                    <Col md={6}>
                      <div className="mb-3">
                        <strong><FaGlobe /> Website:</strong>
                        <div className="mt-1">
                          <a href={company.website} target="_blank" rel="noopener noreferrer">
                            {company.website}
                          </a>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>



                {/* Company Types */}
                {this.props.isMyCompany && (
                  <div className="mb-3">
                    <strong>Loại công ty:</strong>
                    <div className="mt-2">
                      {this.getCompanyTypesBadges(company)}
                      {!company.is_seller && !company.is_factory && !company.is_shipping_agency && !company.is_system && (
                        <span className="text-muted">Chưa phân loại</span>
                      )}
                    </div>
                  </div>
                )}

                <Row>
                </Row>
              </Card.Body>
            </Card>

            {!this.props.isMyCompany && company.metadata && Object.keys(company.metadata).length > 0 && (
              <Card className="mb-4">
                <Card.Header>
                  <h5 className="mb-0">Metadata</h5>
                </Card.Header>
                <Card.Body>
                  <pre className="mb-0">
                    {JSON.stringify(company.metadata, null, 2)}
                  </pre>
                </Card.Body>
              </Card>
            )}
          </Col>

          {!this.props.isMyCompany && (
            <Col md={4}>
              <Card className="mb-4 shadow-sm">
                <Card.Header className="bg-light">
                  <h5 className="mb-0">
                    <i className="fas fa-tags me-2"></i>
                    Loại công ty
                  </h5>
                </Card.Header>
                <Card.Body>
                  {this.getCompanyTypesBadges(company)}
                  {!company.is_seller && !company.is_factory && !company.is_shipping_agency && !company.is_system && (
                    <span className="text-muted">Chưa phân loại</span>
                  )}
                </Card.Body>
              </Card>
            </Col>
          )}


        </Row>

        {/* Edit Modal */}
        <Modal 
          show={this.state.showEditModal} 
          onHide={this.handleCloseEdit} 
          size="lg"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FaEdit className="me-2" />
              Chỉnh sửa thông tin công ty
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tên công ty <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={this.state.editFormData.name}
                      onChange={this.handleEditFormChange}
                      placeholder="Nhập tên công ty"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tên pháp lý</Form.Label>
                    <Form.Control
                      type="text"
                      name="legal_name"
                      value={this.state.editFormData.legal_name}
                      onChange={this.handleEditFormChange}
                      placeholder="Nhập tên pháp lý"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mã công ty <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="company_shortcode"
                      value={this.state.editFormData.company_shortcode}
                      onChange={this.handleEditFormChange}
                      placeholder="VD: KSCTECH, TKT1"
                    />
                    <Form.Text className="text-muted">
                      Chỉ được chứa chữ cái viết hoa và số, từ 2-20 ký tự
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Số điện thoại</Form.Label>
                    <Form.Control
                      type="text"
                      name="tel"
                      value={this.state.editFormData.tel}
                      onChange={this.handleEditFormChange}
                      placeholder="Nhập số điện thoại"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Địa chỉ</Form.Label>
                <Form.Control
                  type="text"
                  name="address"
                  value={this.state.editFormData.address}
                  onChange={this.handleEditFormChange}
                  placeholder="Nhập địa chỉ"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Website</Form.Label>
                <Form.Control
                  type="url"
                  name="website"
                  value={this.state.editFormData.website}
                  onChange={this.handleEditFormChange}
                  placeholder="https://example.com"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Mô tả</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="description"
                  value={this.state.editFormData.description}
                  onChange={this.handleEditFormChange}
                  placeholder="Nhập mô tả về công ty"
                />
              </Form.Group>

              {!this.props.isMyCompany && (
                <Form.Group className="mb-3">
                  <Form.Label>Loại công ty <span className="text-danger">*</span></Form.Label>
                  <div className="mt-2">
                    <Form.Check
                      type="checkbox"
                      id="is_seller"
                      name="is_seller"
                      label="Seller (Bán hàng)"
                      checked={this.state.editFormData.is_seller}
                      onChange={this.handleEditFormChange}
                      className="mb-2"
                    />
                    <Form.Check
                      type="checkbox"
                      id="is_factory"
                      name="is_factory"
                      label="Factory (Sản xuất)"
                      checked={this.state.editFormData.is_factory}
                      onChange={this.handleEditFormChange}
                      className="mb-2"
                    />
                    <Form.Check
                      type="checkbox"
                      id="is_shipping_agency"
                      name="is_shipping_agency"
                      label="Shipping Agency (Vận chuyển)"
                      checked={this.state.editFormData.is_shipping_agency}
                      onChange={this.handleEditFormChange}
                      className="mb-2"
                    />
                    <Form.Check
                      type="checkbox"
                      id="is_system"
                      name="is_system"
                      label="System (Vận hành hệ thống)"
                      checked={this.state.editFormData.is_system}
                      onChange={this.handleEditFormChange}
                    />
                  </div>
                  <Form.Text className="text-muted">
                    Vui lòng chọn ít nhất một loại công ty
                  </Form.Text>
                </Form.Group>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEdit}>
              <FaTimes className="me-1" />
              Hủy
            </Button>
            <Button 
              variant="primary" 
              onClick={this.handleSaveEdit}
              disabled={this.state.editLoading}
            >
              {this.state.editLoading ? (
                <Spinner animation="border" size="sm" className="me-1" />
              ) : (
                <FaSave className="me-1" />
              )}
              {this.state.editLoading ? 'Đang lưu...' : 'Lưu thay đổi'}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  currentCompany: state.companyReducer.currentCompany
});

export default connect(mapStateToProps, {
  getCompanyByID,
  updateCompany
})(CompanyView);
